import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDetentionDefinitionTable extends Layout {
    labelDefinitions: Label;
    sourceDetentionDef: DataSource;
    tableDetentionDefinition: Table;
}
